export default class ImageHelpers {
  static processDataUrlImage (image, dirtyImageDataUrl) {
    image.setAttribute('xlink:href', INKIVE.ImagesFactory.getOriginalUrl(dirtyImageDataUrl));
    INKIVE.C.DEBUG && console.error('Using original (data-url): ' + INKIVE.ImagesFactory.getOriginalUrl(dirtyImageDataUrl));
  }

  static processXlinkImage (image, dirtyImage) {
    let url = dirtyImage.getAttribute('xlink:href');
    const decodedUrl = svgedit.utilities.fromXml(url);
    const originalImageUrl = INKIVE.ImagesFactory.getOriginalUrl(decodedUrl);

    url = originalImageUrl
      ? svgedit.utilities.toXml(originalImageUrl)
      : url;
    image.setAttribute('xlink:href', url);
    INKIVE.C.DEBUG && originalImageUrl && console.error('Using original (basic replace): ' + originalImageUrl);
  }

  static processFlippedImage (image) {
    const originalUrl = image.getAttribute('data-original-href');

    $(image).removeAttr('data-original-href');
    originalUrl && $(image).attr('xlink:href',
      INKIVE.Helpers.isDataURL(originalUrl)
        ? INKIVE.ImagesFactory.getImageUrl(image)
        : originalUrl);
  }

  static getInOrderLoadOptions (savedImageVersion, size) {
    return _.uniq([
      ...INKIVE.ImagesFactory.getRightSizeUrls(savedImageVersion, size),
      savedImageVersion,
      INKIVE.ImagesFactory.getOriginalUrl(savedImageVersion)
    ]).filter(Boolean);
  }

  static loadImageOptions (inOrderLoadOptions, onLoad) {
    return ImageHelpers.loadImage(inOrderLoadOptions.shift())
      .then(onLoad)
      .catch(error => {
        if (inOrderLoadOptions.length) {
          return ImageHelpers.loadImageOptions(inOrderLoadOptions, onLoad);
        }

        return error;
      });
  }

  static loadImage (url) {
    return fetch(url, { method: 'HEAD' })
      .then(response => {
        if (!response.ok) throw new Error('Image not found');

        const image = new Image();
        image.src = url;

        return image;
      });
  }
}
